import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f337687c = () => interopDefault(import('..\\pages\\claim-success.vue' /* webpackChunkName: "pages_claim-success" */))
const _f3a2af46 = () => interopDefault(import('..\\pages\\eligibility.vue' /* webpackChunkName: "pages_eligibility" */))
const _53c24b58 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _003c405e = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _30e9f01e = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages_not-eligible" */))
const _2af3dbb4 = () => interopDefault(import('..\\pages\\patient-information.vue' /* webpackChunkName: "pages_patient-information" */))
const _55fb5d06 = () => interopDefault(import('..\\pages\\print.vue' /* webpackChunkName: "pages_print" */))
const _4d5200d9 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _5b65b7a7 = () => interopDefault(import('..\\pages\\submit-claim.vue' /* webpackChunkName: "pages_submit-claim" */))
const _b625145a = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _517cb236 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _752f9ff9 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _753db77a = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _7559e67c = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _7567fdfd = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _abd4498c = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _0ffc2d22 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/claim-success",
    component: _f337687c,
    name: "claim-success"
  }, {
    path: "/eligibility",
    component: _f3a2af46,
    name: "eligibility"
  }, {
    path: "/error",
    component: _53c24b58,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _003c405e,
    name: "have-a-card"
  }, {
    path: "/not-eligible",
    component: _30e9f01e,
    name: "not-eligible"
  }, {
    path: "/patient-information",
    component: _2af3dbb4,
    name: "patient-information"
  }, {
    path: "/print",
    component: _55fb5d06,
    name: "print"
  }, {
    path: "/rejection",
    component: _4d5200d9,
    name: "rejection"
  }, {
    path: "/submit-claim",
    component: _5b65b7a7,
    name: "submit-claim"
  }, {
    path: "/success",
    component: _b625145a,
    name: "success"
  }, {
    path: "/upload-documents",
    component: _517cb236,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _752f9ff9,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _753db77a,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _7559e67c,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _7567fdfd,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _abd4498c,
    name: "errors-500"
  }, {
    path: "/",
    component: _0ffc2d22,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
